<div class="container">

    <mat-tab-group  [selectedIndex]="selected.value" (selectedTabChange)="back($event)">
      <mat-tab label="Historial Mantenimiento">
        <div class="w-100 mt-4">
        <data-table
        [title]='titleOT'
        [columns]='columnasOT'
        [configuration]='configurationOT'
        [reloadTable]='recargarTablaOT'
        [params]='params'
        [url]='urlTablaOT'
        (view)='clickFilaOT($event)'
        (edit)='editOT($event)'
        (print)='print($event)'
        (addComment)="addComment($event)"
        [headerFilters]="headerFilters"
        [headerFileXlsm]="headerFileXlsm"
        ></data-table>
      </div>

    </mat-tab>

    <mat-tab *ngIf="selected.value == 1" label="Detalle">
      <app-work-order-summary
      [workOrderDetails]="detailsClickRow">
      </app-work-order-summary>
    </mat-tab>
  </mat-tab-group>
</div>

